import gql from 'graphql-tag';

export const EXPORT_NOTIFICATIONS = gql`
  query ExportNotifications($ianaTimeZone: String!, $projectId: String!, $dateFrom: DateTime, $dateTo: DateTime, $fileType: FileType) {
    report {
      exportNotifications(ianaTimeZone: $ianaTimeZone, projectId: $projectId, dateFrom: $dateFrom, dateTo: $dateTo, fileType: $fileType) {
        contentType
        s3Key
      }
    }
  }
`;
